<template>
  <b-container class="esg-top-bar-container"
               fluid>
    <b-row class="esg-top-bar-wrap">
      <b-col class="d-flex align-items-center justify-content-start px-0">
        <!-- User info -->
        <div v-click-outside="closeUserInfoMenuPopOver">
        <span class="user-info-area"
              @click="showUserInfoMenu()">

          <!-- Profile image -->
          <span class="user-profile">
            <!-- Custom image -->
            <img v-if="currentUser.profileImg && currentUser.profileImg !== ''"
                 :src="'data:image/' + currentUser.profileImgName.substr(currentUser.profileImgName.lastIndexOf('.')) + ';base64,' + currentUser.profileImg"
                 alt="user profile">
            <!-- /Custom image -->
            <!-- Default image -->
            <img v-else
                 src="../../../assets/images/icon_user.png"
                 alt="user profile">
            <!-- /Default image -->
          </span>
          <!-- /Profile image -->

          <!-- User ID -->
					<a class="user-detail">{{ currentUser.caller }}</a>
          <!-- /User ID -->

          <!-- User info dropdown menu -->
          <span class="info-menu-area">
            <button type="button"
                    class="btn-user-info"></button>
            <div class="user-info-menu"
                 v-if="!isShowUserInfoMenu">
              <span class="menu">
                <!-- Settings -->
                <a role="button"
                   @click="showUserDetail()">Setting</a>
                <!-- /Settings -->
              </span>
              <span class="menu">
                <!-- Sign out -->
                <div id="sign">
                  <a role="button"
                     @click="signOut"
                     class="">Sign Out</a>
                </div>
                <!-- /Sign out -->
              </span>
            </div>
          </span>
          <!-- /User info dropdown menu -->
        </span>
        </div>
        <!-- /User info -->

        <!-- Navigation -->
        <div class="align-items-center d-none d-sm-flex"
             v-if="currentUser">
          <b-badge @click="redirect($event)"
                   class="btn badge-project mr-1"
                   v-for="role in roles()"
                   :key="role">{{ role }}
          </b-badge>
        </div>
        <!-- /Navigation -->
      </b-col>

      <!-- 알림 영역 -->
      <div class="notify-wrap">
        <div class="notify-area d-none d-sm-block">
          <button type="button"
                  class="btn-notify"
                  :class="{ active: notificationExists }"
                  @click="openNotiPopover">
          </button>
        </div>
        <div class="notify-contents-wrap all-noti"
             v-click-outside="closeNotiPopOver"
             v-if="notiPopoverVisible">
          <div class="notify-contents-area notify-custom-scrollbar">
            <div class="notify-contents"
                 :class="{ 'no-notify': !notificationExists }">
              <div class="notify-box"
                   style="cursor: pointer">
                <template v-for="notification in notifications">
                  <div class="box-area"
                       @click="showDisclosureContentDetail(notification.contentId)"
                       :key="currentUser.caller + notification.id">
                    <div class="tag"
                         :class="convertStatusToKebabCase(notification.status)">
                      {{ convertStatusToTitleCase(notification.status) }}
                    </div>
                    <div class="text-wrap">
                      <div class="subject-wrap">
                        <div class="code">{{ notification.contentId }}</div>
                        <div class="subject">{{ notification.title }}</div>
                      </div>
                      <div class="date">{{ notification.creationDate | formatDatetime }}</div>
                      <div class="message">
                        {{ notification.message }}
                      </div>
                    </div>
                    <b-badge variant="danger"
                             class="btn btn-delete"
                             @click="onDeleteNotification(notification)"
                    />
                  </div>
                </template>
              </div>
              <!-- 알림 내용 없는 경우 -->
              <div class="text-wrap"
                   v-if="!notificationExists">
                <bell-icon/>
                <div class="text">알림이 없습니다</div>
              </div>
              <!-- /알림 내용 없는 경우 -->
            </div>
          </div>
        </div>
      </div>
      <!-- /알림 영역 -->
    </b-row>

    <!--Detail modal start-->
    <b-modal size="lg"
             ref="modalUserInfo"
             header-class="detail-header"
             title="User Information"
             ok-only
             ok-variant="secondary"
             ok-title="Close"
             modal-class="popup-user-info"> <!-- size = xl, lg, sm -->
      <div class="form-user-info">
        <loading :active.sync="detailPopupLoading"
                 :can-cancel="false"
                 :is-full-page="false"></loading>
        <div class="form-list">
          <div class="form-wrap">
            <label for="userId">User ID</label>
            <div class="form-area">
              <div class="form-group">
                <input readonly
                       class="form-control"
                       name="userId"
                       v-model="user.userId">
              </div>
            </div>
          </div>
          <div class="form-wrap">
            <label for="userName">User Name</label>
            <div class="form-area">
              <div class="form-group">
                <input readonly
                       class="form-control"
                       name="userName"
                       v-model="user.userName">
              </div>
            </div>
          </div>
          <div class="form-wrap">
            <label for="file-input">Profile Image</label>
            <div class="form-area">
              <div class="form-group">
                <b-form-file ref="file-input"
                             id="file-input"
                             v-model="user.file"
                             accept="image/*"
                             placeholder="Choose a file or drop it here"
                             drop-placeholder="Drop a file here"></b-form-file>
              </div>
              <button type="button"
                      class="btn btn-success btn-primary"
                      v-on:click="updateProfileImg()">Update
              </button>
            </div>
          </div>
          <div class="form-wrap">
            <label for="preferredRole">Preferred Role</label>
            <div class="form-area">
              <div class="form-group"
                   v-if="roleList">
                <select class="form-control"
                        v-model="user.preferRole"
                        name="preferredRole">
                  <option value=""></option>
                  <option v-for="role in roleList"
                          :value="role"
                          :key="role">{{ role }}
                  </option>
                </select>
                <div class="alert-danger"
                     v-if="submitted && errors.has('preferredRole')">
                  {{ errors.first('preferredRole') }}
                </div>
              </div>
              <button type="button"
                      class="btn btn-success btn-primary"
                      v-on:click="updateUserInfo('role')">{{ 'Update' }}
              </button>
            </div>
          </div>
          <div class="form-wrap">
            <label for="password">Password</label>
            <div class="form-area">
              <div class="form-group">
                <input type="password"
                       class="form-control"
                       name="password"
                       v-model="user.password"
                       v-validate="'min:6|max:40'"
                       @keypress="showReEnterField(user.password)">
                <div class="alert-danger"
                     v-if="submitted && errors.has('password')">{{
                    errors.first('password')
                  }}
                </div>
              </div>
              <button type="button"
                      class="btn btn-success btn-primary"
                      v-on:click="updateUserInfo('password')">{{ 'Update' }}
              </button>
            </div>
          </div>
          <div class="form-wrap">
            <label for="rePassword">Password 확인</label>
            <div class="form-area">
              <div class="form-group mr-2 flex-grow-1">
                <input type="password"
                       class="form-control"
                       name="rePassword"
                       v-model="user.rePassword"
                       v-validate="'min:6|max:40'">
                <div class="alert-danger"
                     v-if="submitted && rePasswordErrorFlag">{{ rePasswordError }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!--Detail modal end -->
  </b-container>
</template>

<script>
import SockJS from "sockjs-client"
import StompJS from "stompjs";
import { Encrypt } from '@/utils.js'
import vClickOutside from 'v-click-outside';
import BellIcon from "@/components/esg/icons/BellIcon.vue";

export default {
  name: 'EsgTopBar',
  components: { BellIcon },
  props: {
    hideToggle: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  async created() {
    try {
      await this.$store.dispatch('report/retrieveNotifications');
      this.subscribeNotification();
    } catch (error) {
      await this.showError(error);
    }
  },
  async beforeDestroy() {
    try {
      await this.unsubscribeNotification();
    } catch (error) {
      await this.showError(error);
    }
  },
  computed: {
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    notifications() {
      return this.$store.getters['report/notifications'];
    },
    notificationCount() {
      return this.notifications ? this.notifications.length : 0;
    },
    notificationExists() {
      return this.notificationCount > 0;
    },
  },
  data() {
    return {
      user: {
        tenantId: '',
        userId: '',
        userName: '',
        password: '',
        rePassword: '',
        preferRole: ''
      },
      submitted: true,
      detailPopupLoading: false,
      showDetailLoading: false,
      rePasswordVisible: false,
      // 드롭다운메뉴 노출 위해 추가
      isShowUserInfoMenu: true,

      roleList: [],
      beforeRole: '',

      rePasswordErrorFlag: false,
      rePasswordError: 'Password does not match.',

      //230607 추가
      notiPopoverVisible: false
    }
  },
  methods: {
    subscribeNotification() {
      // Create a SockJS instance
      const socket = new SockJS(`${WORKMAN_URL}ws/esg`);

      // Create a STOMP client over the SockJS instance
      const client = StompJS.over(socket);

      // Set the debug function, which logs in non-production environments
      client.debug = (str) => {
        if (process.env.NODE_ENV !== 'production') {
          console.log(str);
        }
      };

      // The connect headers with authorization token
      let connectHeaders = {
        Authorization: accessToken()
      };

      // Connect to the WebSocket server
      client.connect(connectHeaders, () => {
        // Subscribe to the ESG notification
        this.subscription = client.subscribe(`/user/queue/esg/notification`, (message) => {
          // Handle the message
          this.$store.commit('report/setNotifications', JSON.parse(message.body));
        });
      }, (error) => {
        console.log('Connection error: ' + error);
      });

      // Handle WebSocket errors
      socket.onclose = (e) => {
        console.log('WebSocket connection closed: ', e);
      };
    },
    async unsubscribeNotification() {
      if (this.subscription) {
        await this.subscription.unsubscribe();
      }
    },
    redirect(event) {
      let role = event.target.innerText;

      if (['Supervisor', 'Administrator'].includes(role)) {
        this.pushRoute('/admin')
      } else if (['Operator'].includes(role)) {
        this.pushRoute('/dashboard');
      } else if (['Chatterer'].includes(role)) {
        this.pushRoute('/chatter');
      } else if (['Surveyor'].includes(role)) {
        this.pushRoute('/survey');
      } else if (['ESG'].includes(role)) {
        this.pushRoute('/esg');
      } else {
        this.pushRoute('/dashboard');
      }
    },
    signOut() {
      this.$store.dispatch('auth/logout');
      this.pushRoute('/signin');
    },
    showUserDetail() {
      if (this.user.tenantId === '') {
        let userInfo = this.currentUser;
        this.user.tenantId = userInfo.tenant;
        this.user.userId = userInfo.caller;
        this.user.userName = userInfo.userkorname;
        this.user.preferRole = userInfo.preferRole;
        this.roleList = userInfo.roles;
        this.beforeRole = userInfo.preferRole;
      }
      this.$refs['modalUserInfo'].show();
    },
    showReEnterField() {
      if (this.rePasswordVisible === false) {
        this.rePasswordVisible = true;
      }
    },
    async updateUserInfo(type) {

      this.submitted = true;
      this.detailPopupLoading = true;

      //let returnFlag = false;
      // Update confirmation
      let encrypted = '';

      const cloneObj = obj => JSON.parse(JSON.stringify(obj));
      let updateData = cloneObj(this.user);

      if (type === 'password') {
        if (updateData.password === '' || updateData.rePassword === '') {
          await this.showMessage("패스워드를 입력해주세요.");
          this.detailPopupLoading = false;
          return;
        }
        if ((updateData.rePassword == null || updateData.rePassword === '') || updateData.rePassword.trim() !== updateData.password.trim()) {
          this.rePasswordErrorFlag = true;
          this.rePasswordError = 'Password does not match.'
          this.detailPopupLoading = false;
          return;
        }
        encrypted = Encrypt(updateData.password); //패스워드 암호화
      } else if (type === 'role') {
        if (updateData.preferRole === '') {
          await this.showMessage("Role을 선택해주세요.");
          this.detailPopupLoading = false;
          return;
        }
        if (this.beforeRole === updateData.preferRole) {
          await this.showMessage("Role이 동일합니다.");
          this.detailPopupLoading = false;
          return;
        }
      }

      this.$validator.validate().then(async valid => {
        if (valid) {
          let params = {
            tenantId: updateData.tenantId,
            userId: updateData.userId,
            userName: updateData.userName,
            preferRole: updateData.preferRole,
            password: encrypted
          };

          try {
            await axios.post('auth/updateUserInfo', params, {
              headers: {
                'Accept': 'application/json',
                'Authorization': accessToken()
              },
              responseType: "blob"
            });

            await this.showMessage('정상적으로 변경되었습니다.');
            this.user.password = '';
            this.user.rePassword = '';
            this.beforeRole = updateData.preferRole;
          } catch (error) {
            await this.showError(error.message);
          } finally {
            this.detailPopupLoading = false;
            this.submitted = false;
          }
        }
      });
    },
    async updateProfileImg() {
      let data = new FormData();
      data.append("file", this.user.file);
      await axios.post("auth/updateProfileImg", data, {
        headers: {
          Accept: "application/json",
          Authorization: accessToken(),
          "Content-Type": "multipart/form-data",
        },
        responseType: "json"
      }).then(response => {
        if (response.data) {
          this.$store.commit("auth/setUserProfile", response.data);
          this.showMessage('정상적으로 변경되었습니다.');
        }
      }).catch((error) => {
        this.showErrorMessage(error);
      });
    },
    // 드롭다운메뉴 노출 위해 추가
    showUserInfoMenu() {
      this.isShowUserInfoMenu = !this.isShowUserInfoMenu;
    },
    closeUserInfoMenuPopOver() {
      this.isShowUserInfoMenu = true;
    },
    closeNotiPopOver() {
      this.notiPopoverVisible = false;
    },
    openNotiPopover() {
      this.notiPopoverVisible = !this.notiPopoverVisible;
    },
    convertStatusToTitleCase(status) {
      return status.toLowerCase()
          .split('_')
          .map(word => {
            return word.slice(0, 1).toUpperCase() + word.slice(1)
          })
          .join(' ')
    },
    convertStatusToKebabCase(status) {
      return this.convertStatusToTitleCase(status).toLowerCase().replace(/ /g, '-')
    },
    showDisclosureContentDetail(id) {
      this.pushRoute({ name: 'EsgDisclosureContentDetail', params: { id } })
    },
    onDeleteNotification(deletedNoti) {
      const newNotifications = this.notifications.filter(noti => noti.id !== deletedNoti.id);
      this.$store.commit('report/initializeNotifications', newNotifications);

      deletedNoti.checkDate = new Date().toISOString();
      axios.patch('esg/disclosure/notifications', deletedNoti, {
        headers: { Authorization: accessToken() }
      });
    }
  },
  filters: {
    formatDatetime(datetime) {
      return !datetime ? null : datetime.split('T').join(" ");
    },
  }
}
</script>

<style scoped>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');

.esg-top-bar-container {
  background-color: #F6F6FA;
  display: flex;
  align-items: center;
}

.esg-top-bar-wrap {
  padding: 16px 28px;
  flex-grow: 1;
}

.user-info-area {
  display: flex;
  align-items: center;
  margin-right: 1.26rem;
  cursor: pointer;
}

.user-detail {
  text-decoration: none;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
}

.user-profile {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 0.93rem;
  border-radius: 50%;
  overflow: hidden;
}

.user-profile img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.info-menu-area {
  position: relative;
}

.btn-user-info {
  display: block;
  width: 24px;
  height: 24px;
  border: none;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 11L12 14L9 11" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>') center/cover no-repeat transparent;
}

.info-menu-area .user-info-menu {
  position: absolute;
  top: 44px;
  left: 50%;
  transform: translateX(-50%);
  width: 140px;
  height: 80px;
  background-color: #fff;
  border-radius: 10px;
  z-index: 1000;
  box-shadow: 0px 14px 30px 0px rgba(0, 0, 0, 0.30);
}

.info-menu-area .user-info-menu::after {
  content: '';
  display: block;
  position: absolute;
  left: 50%;
  top: -12px;
  transform: translateX(-50%);
  width: 14px;
  height: 12px;
  border-top: 0px solid transparent;
  border-bottom: 12px solid #fff;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
}

.info-menu-area .user-info-menu .menu {
  display: block;
  height: 40px;
  padding: 4px;
}

.info-menu-area .user-info-menu .menu:first-child {
  border-radius: 10px 10px 0 0;
}

.info-menu-area .user-info-menu .menu:last-child {
  background: #E7E7EE;
  border-radius: 0 0 10px 10px;
}

.info-menu-area .user-info-menu .menu a {
  display: block;
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 32px;
  color: #2E2E38;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  border-radius: 10px 10px 4px 4px;
}

.info-menu-area .user-info-menu .menu #sign a {
  padding: 0;
  border-color: unset;
  background-color: #E7E7EE;
  color: #2E2E38;
  font-weight: 500;
  border-radius: 4px 4px 10px 10px;
}

.info-menu-area .user-info-menu .menu a:hover {
  background: rgba(46, 46, 56, 0.06);
}

.info-menu-area .user-info-menu .menu #sign a:hover {
  background: rgba(46, 46, 56, 0.08);
}

.badge-project {
  padding: 6px 14px;
  border-radius: 40px;
  background: #747480;
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
}

.badge-project:hover {
  color: #fff;
}

/* 알림 영역 */
.notify-wrap {
  position: relative;
  font-family: 'NanumGothic';
  color: #2E2E38;
}

.notify-area {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0 1.333rem;
  height: 50px;
  padding: 0.533rem;
  border-radius: 40px;
  background-color: #E4E4EC;
}

.notify-area .btn-notify {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 90px;
  border: none;
  background-color: transparent;
}

.notify-area .btn-notify::before {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 28px;
  height: 28px;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M17.5 19.8333H10.5V21C10.5 22.933 12.067 24.5 14 24.5C15.933 24.5 17.5 22.933 17.5 21V19.8333Z" fill="%232E2E38"/><path d="M5.83329 19.8333H22.1666C22.811 19.8333 23.3333 19.311 23.3333 18.6666V17.9832C23.3333 17.6738 23.2104 17.3771 22.9916 17.1583L22.3956 16.5623C22.249 16.4156 22.1666 16.2168 22.1666 16.0094V11.6666C22.1666 7.15629 18.5103 3.49994 13.9999 3.49995C9.48962 3.49997 5.83329 7.1563 5.83329 11.6666V16.0095C5.83329 16.2168 5.75092 16.4157 5.6043 16.5623L5.00833 17.1583C4.78954 17.3771 4.66663 17.6738 4.66663 17.9832V18.6666C4.66663 19.311 5.18896 19.8333 5.83329 19.8333Z" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-repeat: no-repeat;
  transform: translate(-50%, -50%);
}

.notify-area .btn-notify.active::before {
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M17.5 19.8333H10.5V21C10.5 22.933 12.067 24.5 14 24.5C15.933 24.5 17.5 22.933 17.5 21V19.8333Z" fill="%232E2E38"/><path d="M5.83334 19.8333H22.1667C22.811 19.8333 23.3333 19.311 23.3333 18.6666V17.9832C23.3333 17.6738 23.2104 17.3771 22.9916 17.1583L22.3957 16.5623C22.249 16.4156 22.1667 16.2168 22.1667 16.0094V11.6666C22.1667 7.15629 18.5103 3.49994 14 3.49995C9.48967 3.49997 5.83334 7.1563 5.83334 11.6666V16.0095C5.83334 16.2168 5.75097 16.4157 5.60434 16.5623L5.00838 17.1583C4.78959 17.3771 4.66667 17.6738 4.66667 17.9832V18.6666C4.66667 19.311 5.18901 19.8333 5.83334 19.8333Z" stroke="%232E2E38" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="20.5333" cy="6.53334" r="3.73333" fill="%23FF0000"/></svg>');
}

.notify-area .btn-notify:hover,
.notify-area .btn-notify.active {
  background-color: rgba(196, 196, 205, 0.60);
}

.notify-area .notify-list-wrap {
  display: flex;
  align-items: center;
  gap: 0 1.333rem;
}

.notify-area .notify-list {
  display: flex;
  align-items: center;
  position: relative;
  height: 33px;
  font-size: 14px;
  color: #2E2E38;
}

.notify-area .notify-list::after {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  right: -10px;
  width: 1px;
  height: 14px;
  background-color: #C4C4CD;
  transform: translateY(-50%);
}

.notify-area .notify-list:last-child::after {
  display: none;
}

.notify-area .notify-list .notify-item {
  height: 100%;
  padding: 0 1.066rem;
  border: none;
  border-radius: 90px;
  background-color: #E4E4EC;
  font-weight: 500;
  color: #2E2E38;
}

.notify-area .notify-list .notify-item:hover,
.notify-area .notify-list .notify-item.active {
  background-color: rgba(196, 196, 205, 0.60);
}

.notify-area .notify-list .notify-item .num {
  margin-left: 0.666rem;
  font-weight: 700;
}

.notify-contents-wrap {
  position: absolute;
  top: 66px;
  right: 0;
  z-index: 1000;
  width: 30vw;
  min-width: 300px;
  max-width: 500px;
}

.notify-contents-wrap::after {
  content: '';
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  top: -1.8rem;
  right: 1.0rem;
  border-bottom: 15px solid #fff;
  border-top: 15px solid transparent;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
}

.notify-contents-wrap .notify-contents-area {
  width: 100%;
  min-height: 100px;
  max-height: 600px;
  padding: 1.6rem 1.6rem 0;
  border-radius: 10px;
  overflow-y: auto;
  box-shadow: 0px 14px 30px 0px rgba(0, 0, 0, 0.30);
  background-color: #fff;
}

.notify-contents-wrap .notify-contents-area .notify-contents {
  position: relative;
  padding: 2rem 0;
}

.notify-contents-wrap .notify-contents:first-child {
  padding-top: 0;
}

.notify-contents-wrap .notify-contents:last-child {
  padding-bottom: 1.6rem;
}

.notify-contents-wrap .notify-contents::after {
  content: '';
  display: block;
  position: absolute;
  bottom: 0;
  left: -1.6rem;
  width: calc(100% + 48px);
  height: 1px;
  background-color: #dddde3;
}

.notify-contents-wrap .notify-contents:last-child::after {
  display: none;
}

.notify-contents-wrap .notify-contents .title {
  margin-bottom: 1.333rem;
  font-size: 16px;
  font-weight: 700;
}

/* 알림 없는 경우 */
.notify-contents-wrap .notify-contents.no-notify {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0.9333rem;
}

.notify-contents-wrap .notify-contents.no-notify .text-wrap {
  display: flex;
  align-items: center;
}

.notify-contents-wrap .notify-contents.no-notify .text-wrap .text {
  margin-left: 0.2666rem;
  color: #2E2E38;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.5;
}

.notify-contents-wrap .notify-box .box-area {
  padding: 2rem 0;
  border-bottom: 1px solid #dddde3;
  position: relative;
}

.notify-contents-wrap .notify-box .box-area:first-of-type {
  padding-top: 0;
}

.notify-contents-wrap .notify-box .box-area:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.notify-contents-wrap .notify-box .box-area .message {
  padding-top: .4rem;
  font-weight: bold;
}


.notify-contents-wrap .notify-box .box-area .btn-delete {
  position: absolute;
  top: 2rem;
  right: 0;
  display: block;
  width: 20px;
  height: 20px;
  font-size: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15 15L5 5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 5L5 15" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat transparent;
}

.notify-contents-wrap .notify-box .box-area:first-of-type .btn-delete {
  top: 0;
}

/* tag default style */
.notify-contents-wrap .notify-box .tag {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 29px;
  margin-bottom: 0.666rem;
  border-radius: 38px;
  background-color: #F6F6FA;
  font-size: 14px;
  font-weight: 500;
}

/* tag bg orange style */
.notify-contents-wrap .notify-box .tag.to-do {
  background-color: #F6F6FA;
  color: #2E2E38;
}

.notify-contents-wrap .notify-box .tag.in-progress {
  background-color: #F5ECD6;
  color: #FF5C00;
}

.notify-contents-wrap .notify-box .tag.in-progress-red {
  background-color: #F5D6D6;
  color: #F00;
}

.notify-contents-wrap .notify-box .tag.done {
  background-color: #CFDDFF;
  color: #1755CC;
}

.notify-contents-wrap .notify-box .tag.closed {
  background-color: #D7F5D6;
  color: #168D4C;
}

.notify-contents-wrap .notify-box .text-wrap {
  text-decoration: none;
  outline: none;
  color: #2E2E38;
}

.notify-contents-wrap .notify-box .subject-wrap {
  display: flex;
  gap: 0 1.133rem;
  margin-block: 0.4rem;
  font-weight: 500;
}

.notify-contents-wrap .notify-box .subject-wrap .subject {
  position: relative;
  font-weight: 700;
}

.notify-contents-wrap .notify-box .text-wrap:hover .subject-wrap .subject {
  text-decoration: underline;
}

.notify-contents-wrap .notify-box .subject-wrap .subject::before {
  content: '';
  display: block;
  position: absolute;
  top: 0.4rem;
  left: -0.6rem;
  width: 1px;
  height: 10px;
  background-color: #2E2E38;
}

/* scrollbar */
.notify-custom-scrollbar::-webkit-scrollbar {
  width: 20px;
  border-top: 24px solid transparent;
  border-bottom: 24px solid transparent;
  border-right: 14px solid transparent;
  background-clip: padding-box;
}

.notify-custom-scrollbar::-webkit-scrollbar-track {
  width: 6px;
  background-color: #F6F6FA;
  border-top: 24px solid transparent;
  border-bottom: 24px solid transparent;
  border-right: 14px solid transparent;
  background-clip: padding-box;
}

.notify-custom-scrollbar::-webkit-scrollbar-thumb {
  width: 100%;
  background-color: #C4C4CD;
  border-top: 24px solid transparent;
  border-bottom: 24px solid transparent;
  border-right: 14px solid transparent;
  background-clip: padding-box;
}

.table th, td {
  margin: 0px;
  vertical-align: middle !important;
}

.form-control, .form-group {
  margin: 0px;
}
</style>

<style>
/* user info 팝업 */
.popup-user-info.modal.show .modal-dialog {
  margin: 0 auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.popup-user-info .modal-content {
  border-radius: 20px;
}

.popup-user-info .modal-header {
  align-items: center;
  padding: 2.083vw 2.666rem 1.041vw;
  border-radius: 20px 20px 0 0;
  border-bottom: 0px;
}

.popup-user-info .modal-title {
  margin-bottom: 0 !important;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
}

.popup-user-info .modal-header .close {
  width: 30px;
  height: 30px;
  margin: 0;
  font-size: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none"><path d="M22.5 22.5L7.5 7.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><path d="M22.5 7.5L7.5 22.5" stroke="%232E2E38" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>') center no-repeat;
}

.popup-user-info .modal-body {
  padding: 1.041vw 2.666rem;
}

.popup-user-info .modal-body .form-user-info .form-list {
  display: flex;
  flex-direction: column;
  gap: 1.562vw 0;
}

.popup-user-info .form-user-info .form-list label {
  padding-left: 0.4rem;
  margin-bottom: 0.53rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}

.popup-user-info .form-user-info .form-area {
  display: flex;
  align-items: center;
  gap: 0 0.8rem;
}

.popup-user-info .form-user-info .form-area .form-group {
  flex: 1 0;
}

.popup-user-info .form-user-info .custom-file {
  height: 40px;
}

.popup-user-info .form-user-info .custom-file-input {
  height: 100%;
}

.popup-user-info .form-user-info .custom-file-input ~ .custom-file-label[data-browse]::after {
  content: none;
}

.popup-user-info .form-user-info .custom-file-input.focus {
  border: none;
  box-shadow: none;
}

.popup-user-info .form-user-info .form-list .custom-file-label {
  height: 100%;
  padding: 0.533rem 1.066rem;
  margin-bottom: 0;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
}

.popup-user-info .form-user-info .custom-file-label span {
  color: #747480;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.popup-user-info .modal-body input.form-control {
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem !important;
  border-radius: 10px !important;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150% !important;
}

.popup-user-info .modal-body input.form-control:read-only {
  background-color: #E0E0E7;
  color: #747480;
}

.popup-user-info .modal-body select.form-control {
  -o-appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

.popup-user-info .modal-footer {
  justify-content: center;
  padding: 1.562vw 2.666rem 2.604vw;
  border-top: 0px;
  border-radius: 0 0 20px 20px;
}

.popup-user-info .btn {
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.popup-user-info .btn-primary {
  width: 148px;
  height: 40px;
  background-color: #2E2E38;
  color: #FFE600;
  border-color: transparent;
}

.popup-user-info .btn-primary:hover {
  color: #FFE600;
  background-color: #0D0D17;
  border-color: transparent;
}

.popup-user-info .btn-primary.disabled,
.popup-user-info .btn-primary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}

.popup-user-info .modal-footer .btn-secondary {
  width: 146px;
  height: 40px;
  margin: 0;
  border-radius: 10px;
  background: #747480;
  color: #fff;
  border-radius: 10px;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
}

.popup-user-info .modal-footer .btn-secondary:hover {
  background-color: #565662;
}

.popup-user-info .modal-footer .btn-secondary.disabled,
.popup-user-info .modal-footer .btn-secondary:disabled {
  color: #9C9CA8;
  background-color: #C4C4CD;
  border-color: transparent;
}
</style>
